/**
 * Generación de IDs únicos
 */

import { nanoid } from 'nanoid';

/**
 * Genera un ID único para protocolos
 * Prefijo 'prot-' para identificación visual
 */
export function generateProtocolId(): string {
  return `prot-${nanoid(10)}`;
}

/**
 * Genera un ID único para subtareas
 * Prefijo 'sub-' para identificación visual
 */
export function generateSubtaskId(): string {
  return `sub-${nanoid(8)}`;
}

/**
 * Genera un ID único genérico
 */
export function generateId(prefix?: string): string {
  const id = nanoid(10);
  return prefix ? `${prefix}-${id}` : id;
}
